import * as React from 'react';
import { Props } from '@websky/core/src/SeatMap/components/SeatsInfo/SeatsInfo';
import { FlightClass } from '@websky/graphql';
import { useTheme } from '@websky/core/src/theme';
import { useTranslation } from 'react-i18next';
import { GdsSeatService } from '@websky/core/src/SeatMap/types';
import Amenities from '@websky/core/src/Amenities';

const SeatsInfo: React.FC<Props> = props => {
	const theme = useTheme('SeatMap').SeatsInfoStyles;
	const { t } = useTranslation('SeatMap');

	const seatsByClassesMap = React.useMemo(() => {
		const seatsByClasses = new Map<FlightClass, GdsSeatService[]>();

		props.seatsInfo.forEach(seat => {
			seatsByClasses.set(
				seat.serviceClass,
				seatsByClasses.has(seat.serviceClass) ? [...seatsByClasses.get(seat.serviceClass), seat] : [seat]
			);
		});

		return seatsByClasses;
	}, [props.seatsInfo]);

	const seatsByClasses = React.useMemo(() => {
		const seatsByClasses: {
			image: string;
			classType: FlightClass;
			seats: GdsSeatService[];
		}[] = [];

		seatsByClassesMap.forEach((seats, classType) => {
			seatsByClasses.push({
				classType,
				seats,
				image: seats.find(seat => !!seat.serviceImage)?.serviceImage
			});
		});

		return seatsByClasses;
	}, [seatsByClassesMap]);

	const renderSeatsByClasses = (mobile?: boolean) => {
		return seatsByClasses.map(seats => {
			return (
				<div>
					<div className={theme.classInfo}>
						<img className={theme.image} src={seats.image} alt={seats.classType} />

						<div className={theme.classInfo__payload}>
							<div>{t(seats.classType)}</div>

							{props.amenities && <Amenities amenities={props.amenities} />}
						</div>
					</div>
				</div>
			);
		});
	};

	return <>{renderSeatsByClasses()}</>;
};

export default SeatsInfo;
